<template>
  <div
    class="mx-3 mapTitle py-6 mb-6 d-flex justify-space-between align-center"
  >
    <div>
      <span class="ct-text-subtitle3 ct-text-bolder mapTree">{{ title }}</span>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss" scoped>
.mapTitle {
  border-style: solid;
  border-width: 0 0 2px 0;
  border-color: #91ad70;
}

.mapTree {
  position: relative;
  padding-left: 23px;
  color: #2f4b3b;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    content: "";
    width: 15px;
    height: 100%;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url("~@/assets/images/map/map_title_icon.svg");
  }
}
</style>
